export type NameType = 'open';

export const name: NameType = 'open';
